import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { marcasAPI } from '../services/api';
import { useApp } from '../context/AppContext';

const Marcas = () => {
  const { refreshCatalogos, config } = useApp();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formData, setFormData] = useState({ nombre: '', descripcion: '', iva_porcentaje: 15 });

  useEffect(() => { load(); }, []);

  const load = async () => {
    try { setLoading(true); const res = await marcasAPI.getAll(); if (res.data.success) setItems(res.data.data); }
    catch (e) { toast.error('Error al cargar'); } finally { setLoading(false); }
  };

  const openModal = (item = null) => {
    if (item) { setEditando(item); setFormData({ nombre: item.nombre, descripcion: item.descripcion || '', iva_porcentaje: item.iva_porcentaje || 15 }); }
    else { setEditando(null); setFormData({ nombre: '', descripcion: '', iva_porcentaje: config.iva_defecto || 15 }); }
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre) { toast.error('El nombre es requerido'); return; }
    try {
      if (editando) { await marcasAPI.update(editando.id, formData); toast.success('Actualizado'); }
      else { await marcasAPI.create(formData); toast.success('Creado'); }
      setShowModal(false); load(); refreshCatalogos();
    } catch (e) { toast.error(e.response?.data?.error || 'Error'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar?')) return;
    try { await marcasAPI.delete(id); toast.success('Eliminado'); load(); refreshCatalogos(); }
    catch (e) { toast.error('Error'); }
  };

  return (
    <div>
      <div className="d-flex justify-content-between mb-4">
        <p className="text-muted mb-0">Gestiona las marcas de productos</p>
        <button className="btn btn-primary" onClick={() => openModal()}><i className="bi bi-plus-lg me-2"></i>Nueva</button>
      </div>

      {loading ? <div className="loading-container"><div className="spinner-border text-primary"></div></div>
      : items.length === 0 ? <div className="card"><div className="card-body empty-state"><i className="bi bi-bookmark-star"></i><h5>No hay marcas</h5></div></div>
      : <div className="row g-4">{items.map(item => (
        <div key={item.id} className="col-sm-6 col-lg-4 col-xl-3">
          <div className="card h-100">
            <div className="card-body">
              <div className="d-flex justify-content-between mb-3">
                <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 48, height: 48, background: 'linear-gradient(135deg, #7bc47f 0%, #5aa55e 100%)' }}>
                  <i className="bi bi-award-fill text-white"></i>
                </div>
                <span className={`badge bg-${item.activo ? 'success' : 'secondary'}`}>{item.activo ? 'Activo' : 'Inactivo'}</span>
              </div>
              <h5 className="card-title mb-2">{item.nombre}</h5>
              <p className="text-muted small mb-3">{item.descripcion || 'Sin descripción'}</p>
              <div className="d-flex justify-content-between">
                <span className="text-muted small"><i className="bi bi-box me-1"></i>{item.total_productos || 0} productos</span>
                <div className="btn-group btn-group-sm">
                  <button className="btn btn-outline-primary" onClick={() => openModal(item)}><i className="bi bi-pencil"></i></button>
                  <button className="btn btn-outline-danger" onClick={() => handleDelete(item.id)}><i className="bi bi-trash"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}</div>}

      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog"><div className="modal-content">
            <div className="modal-header"><h5 className="modal-title">{editando ? 'Editar' : 'Nueva'} Marca</h5><button className="btn-close" onClick={() => setShowModal(false)}></button></div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="mb-3"><label className="form-label">Nombre *</label><input type="text" className="form-control" value={formData.nombre} onChange={e => setFormData({...formData, nombre: e.target.value})} required /></div>
                <div className="mb-3"><label className="form-label">Descripción</label><textarea className="form-control" value={formData.descripcion} onChange={e => setFormData({...formData, descripcion: e.target.value})} rows="2" /></div>
                <div className="mb-3"><label className="form-label">IVA %</label><input type="number" step="0.01" className="form-control" value={formData.iva_porcentaje} onChange={e => setFormData({...formData, iva_porcentaje: e.target.value})} /></div>
              </div>
              <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button><button type="submit" className="btn btn-primary">Guardar</button></div>
            </form>
          </div></div>
        </div>
      )}
    </div>
  );
};

export default Marcas;
